module.exports = __webpack_public_path__ + "img/Cieslewicz.86a51973.jpg";